import { createFileRoute } from "@tanstack/react-router";

import AuditReadinessPage from "@/features/dashboard/pages/audit-readiness";

export const Route = createFileRoute("/(app)/dashboard/audit-readiness")({
  component: () => <AuditReadinessPage />,
});
